import { axios } from "@/libraries/axios";
import type {
	CreateTeamFormSchema,
	GetTeamsParamsSchema,
	UpdateTeamFieldSchema,
} from "@/schemas";
import type {
	CreateMessageResponse,
	GetTeamResponseType,
	GetTeamsResponse,
	PatchUpdateTeamResponseType,
	PostAssignTeamCaseExternalPayload,
	PostCreateTeamResponseType,
} from "@/types";
import type { AxiosRequestConfig } from "axios";

class TeamService {
	get defaultParamsGetTeams(): Partial<GetTeamsParamsSchema> {
		return {
			page: 1,
			limit: 25,
		};
	}
	async getTeams(params: GetTeamsParamsSchema, config?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetTeamsResponse>("/api/v1/teams", {
				params: {
					...this.defaultParamsGetTeams,
					...params,
				},
				...config,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async getTeam(id: number) {
		try {
			const res = await axios.get<GetTeamResponseType>(`/api/v1/teams/${id}`);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async exit(id: number, config?: AxiosRequestConfig) {
		try {
			const res = await axios.get(`/api/v1/teams/${id}/exit`, config);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async delete(id: number, config?: AxiosRequestConfig) {
		try {
			const res = await axios.delete(`/api/v1/teams/${id}`, config);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async removeUser(params: any, config?: AxiosRequestConfig) {
		try {
			const { id, ...payload } = params;
			const res = await axios.put(`/api/v1/teams/${id}/exit`, payload, config);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async create(payload: CreateTeamFormSchema, config?: AxiosRequestConfig) {
		try {
			const { user_ids, ...team } = payload;
			const res = await axios.post<PostCreateTeamResponseType>(
				"/api/v1/teams",
				{
					team: {
						...team,
						user_ids: Array.from(user_ids),
					},
				},
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async update(payload: UpdateTeamFieldSchema, config?: AxiosRequestConfig) {
		try {
			const { id, ...team } = payload;
			const res = await axios.patch<PatchUpdateTeamResponseType>(
				`/api/v1/teams/${id}`,
				{
					team,
				},
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async assignCaseExternal(payload: PostAssignTeamCaseExternalPayload) {
		try {
			const { id, caseId, message } = payload;
			const res = await axios.post<CreateMessageResponse>(
				`/api/v1/teams/${id}/cases/${caseId}/set_external`,
				{
					message,
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const teamService = Object.freeze(new TeamService());
